<div class="flex-1 min-h-0 overflow-y-auto">
  <div class="max-w-3xl mx-auto p-4 sm:p-6 space-y-6">
    <div>
      <h2 class="text-lg font-semibold text-slate-800">Configuración</h2>
      <p class="text-sm text-slate-500">Administra los números de WhatsApp y sus preferencias para esta sucursal.</p>
    </div>

    <div class="space-y-4">
      @for (telefono of telefonos(); track telefono.id) {
        <div class="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
          <div class="px-5 py-4 flex items-start justify-between gap-4">
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 flex-wrap">
                <span class="font-semibold text-slate-800 text-base">{{ telefono.titulo }}</span>
                @if (telefono.activo) {
                  <span class="text-[10px] px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 font-medium">
                    Activo
                  </span>
                } @else {
                  <span class="text-[10px] px-2 py-0.5 rounded-full bg-red-50 text-red-700 font-medium">
                    Inactivo
                  </span>
                }
                <span class="text-[10px] px-2 py-0.5 rounded-full font-medium"
                  [class.bg-blue-50]="telefono.proveedor === 'OFICIAL'"
                  [class.text-blue-700]="telefono.proveedor === 'OFICIAL'"
                  [class.bg-amber-50]="telefono.proveedor === 'NO_OFICIAL'"
                  [class.text-amber-700]="telefono.proveedor === 'NO_OFICIAL'"
                >
                  {{ telefono.proveedor === 'OFICIAL' ? 'API Oficial' : 'No Oficial' }}
                </span>
                @if (telefono.usar_para_comprobantes) {
                  <span class="text-[10px] px-2 py-0.5 rounded-full bg-green-100 text-green-800 font-medium">
                    <i class="bi bi-check-circle-fill text-[10px] mr-1"></i>Comprobantes
                  </span>
                }
              </div>

              <p class="text-sm text-slate-600 mt-1.5 font-mono">{{ telefono.numero }}</p>

              @if (telefono.descripcion) {
                <p class="text-xs text-slate-400 mt-1">{{ telefono.descripcion }}</p>
              }

              <div class="mt-3 flex flex-wrap items-center gap-x-6 gap-y-1 text-xs text-slate-400">
                @if (telefono.proveedor === 'NO_OFICIAL' && telefono.instance_name) {
                  <span class="flex items-center gap-1">
                    <i class="bi bi-server"></i>
                    {{ telefono.instance_name }}
                  </span>
                }
                @if (telefono.proveedor === 'OFICIAL' && telefono.meta_phone_number_id) {
                  <span class="flex items-center gap-1">
                    <i class="bi bi-meta"></i>
                    {{ telefono.meta_phone_number_id }}
                  </span>
                }
                <span class="flex items-center gap-1">
                  <i class="bi bi-calendar3"></i>
                  {{ telefono.created_at | date: 'dd/MM/yyyy' }}
                </span>
              </div>
            </div>

            <div class="flex flex-col items-end gap-2 shrink-0">
              @if (telefono.proveedor === 'NO_OFICIAL' && telefono.activo) {
                <label class="relative inline-flex items-center cursor-pointer gap-2">
                  <span class="text-xs text-slate-500">Comprobantes</span>
                  <input
                    type="checkbox"
                    class="sr-only peer"
                    [checked]="telefono.usar_para_comprobantes"
                    (change)="toggleComprobantes.emit(telefono)"
                  />
                  <div
                    class="w-9 h-5 rounded-full bg-slate-200 peer-checked:bg-green-500 relative
                      after:absolute after:top-0.5 after:start-[2px] after:bg-white after:rounded-full
                      after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-[14px]"
                  ></div>
                </label>
              }
            </div>
          </div>
        </div>
      }
    </div>

    <div class="rounded-xl border border-slate-200 bg-slate-50 p-5">
      <h3 class="text-sm font-semibold text-slate-700 mb-2 flex items-center gap-2">
        <i class="bi bi-info-circle text-blue-500"></i>
        Información
      </h3>
      <ul class="text-xs text-slate-500 space-y-1.5">
        <li>• Solo un teléfono no oficial por sucursal puede enviar comprobantes.</li>
        <li>• Al activar uno, el anterior se desactiva automáticamente.</li>
        <li>• El teléfono debe estar conectado a WhatsApp para enviar documentos.</li>
        <li>• Para agregar o eliminar teléfonos, contacta al administrador del sistema.</li>
      </ul>
    </div>
  </div>
</div>
